<script setup lang="ts">
</script>

<template>
  <div class="details-box-container">
    <p>
      <slot />
    </p>
    <slot name="pagination" />
  </div>
</template>

<style scoped lang="scss">
.details-box-container {
  @apply text-primary/40 text-lg px-4 py-2 rounded-lg flex justify-between items-center bg-card-background/5 h-8 box-content;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;

  @include sm {
    @apply flex-col justify-start items-stretch gap-y-2 pt-4 h-fit;
  }
}
</style>